export const isTerminal = (pointType?: unknown): pointType is 'terminal' => pointType === 'terminal'
